import { Injectable } from "@angular/core";
import { Response} from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Constants } from "../constants/constants";
import { HttpClient } from "../authentication/httpClient";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

@Injectable()
export class PurchaseFormService {

	constructor(private http: HttpClient) { }

	getPurchaseForm(): Observable<IPurchaseFormModel> {
		return this.http.get(`${Constants.restUrl}PurchaseForm/GetPurchaseForm`, {}).map((res: Response) => res.json()).catch(this.handleError);
	}

	addPurchaseForm(approval: IAppovalModel): Observable<IAppovalModel> {
		return this.http.post(`${Constants.restUrl}PurchaseForm/AddPurchaseForm`, approval).map((res: Response) => res.json());
	}

	savePurchaseForm(approval: IAppovalModel): Observable<IAppovalModel> {
		return this.http.post(`${Constants.restUrl}PurchaseForm/SavePurchaseForm`, approval).map((res: Response) => res.json());
	}

	updatePurchaseForm(approval: IAppovalModel): Observable<IAppovalModel> {
		return this.http.put(`${Constants.restUrl}PurchaseForm/UpdatePurchaseForm`, approval).map((res: Response) => res.json());
	}

	uploadAttachments(attachments: Array<File>, formId: number, formTypeId: number) {
		let formData = new FormData();

		for (let i = 0; i < attachments.length; i++) {
			formData.append("files", attachments[i], attachments[i].name);
		}

		formData.append("formId", formId.toString());
		formData.append("formTypeId", formTypeId.toString());

		return this.http.post(
			`${Constants.restUrl}PurchaseForm/UploadAttachments`,
			formData
		).map((res: Response) => res.json());
	}

    copyAttachments(formId: number, prevFormId: number, formTypeId: number) {       

        return this.http.post(`${Constants.restUrl}PurchaseForm/CopyAttachment/${formId}/${prevFormId}/${formTypeId}`, {}).map((res: Response) => res.json());
    }

	removeAttachment(attachment: IAttachmentModal): Observable<boolean> {
		return this.http.delete(`${Constants.restUrl}PurchaseForm/RemoveAttachment/${attachment.id}`, {}).map((res: Response) => res.json());
    }

	getPurchaseFormManagers(departmentId: number, managerEmail: string): Observable<Array<IPurchaseFormManagerModel>> {
		return this.http.get(`${Constants.restUrl}PurchaseForm/GetPurchaseFormManagers/${departmentId}/${managerEmail}`, {}).map((res: Response) => res.json()).catch(this.handleError);
	}

	getGLCodeList(query: string): Observable<any> {
		return this.http.get(`${Constants.restUrl}PurchaseForm/GetGLCodeList/${query}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	isGlCodeExist(glCode: string): Observable<boolean> {
		return this.http.get(`${Constants.restUrl}PurchaseForm/IsGLCodeExist/${glCode}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	formatGLCode(input: string, format: Array<number>, sep: string): string {
		var output = "";
		var idx = 0;
		for (var i = 0; i < format.length && idx < input.length; i++) {
			output += input.substr(idx, format[i]);
			if (idx + format[i] < input.length) output += sep;
			idx += format[i];
		}
		output += input.substr(idx);
		return output;
	}

	private handleError(error: any): Observable<any> {
		console.error("An error occurred", error);
		return Observable.throw(error.message || error);
	}
}